<template>
  <ProseCallout icon="lucide-app-window-mac">
    阅读并编辑实时示例中的内容
    <NuxtLink :to="to">
      {{ computedTitle }}
    </NuxtLink>.
  </ProseCallout>
</template>

<script setup lang="ts">
import type { ComputedRef } from 'vue'

const props = defineProps<{
  to: string
  title?: string
}>()

const computedTitle: ComputedRef<string> = computed(() => createBreadcrumb(props.to))
</script>
